import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTuningFastTurns = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={31}
    fill="none"
    viewBox="0 0 34 31"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-tuning-fast-turns_svg__a)">
      <path
        fill="#fff"
        d="M20.719 11.938a.777.777 0 0 1 0 1.156l-5.5 4.75c-.469.406-1.219.062-1.219-.594v-2.625c-3.406.406-4.75 1.844-3.531 5.688.156.5-.438.906-.875.593C8.219 19.906 7 18 7 16.094c0-4.125 2.938-5.407 7-5.719V7.781c0-.625.75-.968 1.219-.562l5.5 4.718Zm4 0c.343.312.343.843 0 1.187l-5.5 4.719c-.469.406-1.219.062-1.219-.563v-.5l4.906-4.25L18 8.25v-.469c0-.625.75-.968 1.219-.562l5.5 4.718Z"
      />
    </g>
    <defs>
      <filter
        id="icon-tuning-fast-turns_svg__a"
        width={34.063}
        height={32}
        x={-1}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_29404"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_29404"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_29404"
          result="effect2_dropShadow_6025_29404"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_29404"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconTuningFastTurns;
